import { Card } from '@/components/ui/card';
import DateRangePicker from '@/components/filters/DateRangePicker';

const ConversionsPage = () => (
  <div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="text-2xl font-semibold text-white">Conversions</h2>
        <p className="text-sm text-slate-400">Break down conversion rates by source, landing page, and device.</p>
      </div>
      <DateRangePicker />
    </div>

    <Card title="Conversion Rates">
      <p className="text-sm text-slate-400">Join events with transactions for channel attribution.</p>
    </Card>

    <Card title="Landing Page Performance">
      <p className="text-sm text-slate-400">Table with bounce proxy, time on page, and conversion.</p>
    </Card>
  </div>
);

export default ConversionsPage;
